import { gql } from "@apollo/client"

export const DELETE_PROMPT = gql`
    mutation deletePrompt($mediaUUID: String!) {
        deletePrompt(mediaUUID: $mediaUUID)
    }
`
